import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from "./CustomBodyContent";
import VisualContent from './VisualContent';
import {
  SLEditModal,
} from '~/pages/Sistema/componentes/SistemaList';

import { store } from "~/store";
import { loadingToggle } from "~/store/modules/loadingModal/actions";

export default function RelatorioOrdemServicoAnalista() {
  const dispatch = store.dispatch;
  const [data, setData] = useState([]);
  const [pageData, setPageData] = useState([]);
  const [loadedData, setLoadedData] = useState(false);
  const [mountedData, setMountedData] = useState();

  const [previsaoInicio, setPrevisaoInicio] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [previsaoFinal, setPrevisaoFinal] = useState(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0));
  const [idProjeto, setIdProjeto] = useState();
  const [idCliente, setIdCliente] = useState();
  const [statusAprovacao, setStatusAprovacao] = useState();
  const [idEtapa, setIdEtapa] = useState();
  const [idAnalista, setIdAnalista] = useState();

  useEffect(() => {
    dispatch(loadingToggle());
    api.get(
      '/signed/empresa/gestorprojeto/relatorios/ossrelatorioanalista',
      {
        params: { dataEmissaoDe: previsaoInicio, dataEmissaoAte: previsaoFinal, statusAprovacao, idCliente, idProjeto }
      }
    ).then(r => {
      dispatch(loadingToggle());
      setData(r?.data);
    });
  }, [previsaoInicio, previsaoFinal, statusAprovacao, idCliente, idProjeto]);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            className="container-pj"
            requests={{
              findOne: thisData =>
                api.get('/signed/empresa/gestorprojeto/relatorios/osrelatorioanalista', {
                  params: { id: thisData.id },
                }),
            }}
            manual={true}
          >
            <SLEditModal
              menu={true}
              title="Visualizar Ordem de Serviço"
              setter={setMountedData}
            >
              {mountedData && (
                <VisualContent {...{ mountedData }} />
              )}
            </SLEditModal>

            <CustomBodyContent {...{
              data,
              previsaoInicio,
              setPrevisaoInicio,
              previsaoFinal,
              setPrevisaoFinal,
              statusAprovacao,
              setStatusAprovacao,
              idCliente,
              setIdCliente,
              idProjeto,
              setIdProjeto,
              idEtapa,
              setIdEtapa,
              idAnalista,
              setIdAnalista,
            }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
